import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { ISectionProps, Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents";
import { JobRequestDetailIconSection } from "@/views/JobRequests/Detail/components";

export interface ISupplier {
  contactPersonEmail: string;
  contactPersonName: string;
  contactPersonPhone: string;
  legalName: string;
  vatNo: string;
}

export interface IWorkOrderCommercialSectionProps extends ISectionProps {
  supplier: ISupplier;
  otherSupplier: boolean;
}

export const WorkOrderCommercialSection: FC<IWorkOrderCommercialSectionProps> = memo(
  ({ supplier, otherSupplier, ...sectionProps }) => {
    const { t } = useTranslation("session");
    const isSmallScreen = useMedia(MEDIA_SIZE_SM);

    return (
      <Section
        width={12}
        padding={["md", "lg"]}
        innerMargin="md"
        flex
        direction="column"
        borderRadius={!isSmallScreen}
        shadow={isSmallScreen ? "none" : "default"}
        {...sectionProps}>
        <Header size="sm" color="black" weight="bold">
          {t("WORK_ORDERS.DETAILS.COMMERCIAL_CONTACT_SECTION.HEADER")}
        </Header>

        <Flex direction={isSmallScreen ? "column" : "row"} innerMargin="sm">
          <Flex width={isSmallScreen ? 12 : 6} innerMargin="md">
            <Flex align="flex-start" innerMargin="xs" direction="column">
              <Flex innerMargin="sm">
                <Icon color="grey2" icon="profile" size="md" />
                <Text size="md" weight="bold" text={supplier.contactPersonName} />
              </Flex>

              <Flex innerMargin="sm">
                <Icon color="grey2" icon="messages" size="md" />
                <Text size="md" text={supplier.contactPersonEmail} />
              </Flex>

              <Flex innerMargin="sm">
                <Icon color="grey2" icon="phone" size="md" />
                <Text size="md" text={supplier.contactPersonPhone} />
              </Flex>
            </Flex>
          </Flex>

          {!otherSupplier && (
            <Flex width={isSmallScreen ? 12 : 6} direction="column" innerMargin="sm">
              <JobRequestDetailIconSection
                label={t("WORK_ORDERS.DETAILS.COMMERCIAL_CONTACT_SECTION.SUPPLIER_LABEL")}
                value={supplier.legalName}
                icon="company"
                grow={0}
              />

              <JobRequestDetailIconSection
                label={t("WORK_ORDERS.DETAILS.COMMERCIAL_CONTACT_SECTION.VAT_NUMBER_LABEL")}
                value={supplier.vatNo}
                icon="vat"
                grow={0}
              />
            </Flex>
          )}
        </Flex>
      </Section>
    );
  },
);
